<template>
  <transition name="fade">
    <div class="delete_modal_overlay" role="dialog" aria-modal="true">
      <div class="delete_modal_card">
        <!-- Replaced warning with red trash icon -->
        <div class="modal_icon_wrapper">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </div>
        <h3 class="modal_title">Delete this note?</h3>
        <p class="modal_desc">This action cannot be undone.</p>

        <div class="modal_actions">
          <button
            type="button"
            class="btn btn_cancel"
            :disabled="loading"
            @click="$emit('cancel')"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn_confirm"
            :disabled="loading"
            @click="$emit('confirm')"
          >
            {{ loading ? 'Deleting...' : 'Yes, Delete' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NotesDeleteModal',
  props: {
    loading: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.delete_modal_overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
}

.delete_modal_card {
  background: #000000; /* Dark background matching the UI */
  color: #ffffff;
 border-radius: 8px;
  max-width: 500px;
  width: 100%;
  padding: 25px 15px;
  text-align: center;
  /* Distinct golden/yellowish outer glow as requested */
  box-shadow: 0 0 13px rgba(255, 213, 0, 0.6);
  border: 1px solid rgba(234, 179, 8, 0.35); /* Slight yellowish tint on border */

  .modal_icon_wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(239, 68, 68, 0.15); /* Very soft dark red circle */
    font-size: 24px;
    color: #ef4444; /* Vivid red trash icon */
    margin-bottom: 20px;
  }

  .modal_title {
    font-size: 18px;
    font-weight: 400;
    margin: 0 0 10px 0;
    letter-spacing: -0.02em;
  }

  .modal_desc {
    font-size: 14px;
    color: #9ca3af;
    margin: 0 0 28px 0;
    line-height: 1.4;
  }

  .modal_actions {
    display: flex;
    justify-content: center;
    gap: 16px;

    .btn {
      flex: 1;
      max-width: 125px;
      padding: 8px 14px;
      font-size: 15px;
      border-radius: 5px;
      cursor: pointer;
      font-weight: 600;
      border: none;
      transition: all 0.25s ease;

      &.btn_cancel {
        background: #5c1818; /* Dark Red Cancel */
        color: #ffffff;
        &:hover {
          background: #471212;
        }
        &:disabled {
          opacity: 0.5;
        }
      }

      &.btn_confirm {
        background: #004d5a; /* Dark Teal Delete */
        color: #ffffff;
        &:hover {
          background: #00363f;
        }
        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>